import { Department } from '@/types/graphql'

export default (department: Maybe<Partial<Department>>) => {
  const code = department?.code?.trim()
  const label = department?.label?.trim()

  return `${code ?? '-'}${label ? ' - ' : ''}${label}`
}
